import { ConfigSetting } from "./config-setting";
import {NGXLogger} from "ngx-logger";
import {Optional} from "@angular/core";
import {AppInjector} from "../../app.module";

export class AppSettings {
    private items: ConfigSetting[] = [];
    private logger: NGXLogger;

    constructor(settings: ConfigSetting[]) {
        this.logger = AppInjector.get(NGXLogger);
        this.items = settings
    }


    //////////
    setSettings(settings :  ConfigSetting[]){
        this.items = settings;
    }

    //////////
    getSettings() {
        return this.items;
    }

    ///////////
    getSetting(name: string) : ConfigSetting | undefined{
        let setting = this.items.find(setting => setting.name == name);
        return setting;
    }

    ///////////
    getSettingValue(name: string) : string {
        let setting = this.items.find(setting => setting.name == name);
        if (setting != undefined) {
            this.logger.debug("getSettingValue for "+ name + " Found:" + setting.value);
            return setting.value;
        }
        else
        {
            this.logger.warn("getSettingValue not found for", name);
        }

        return "";
    }
}
